export const emailRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^ <>()[\]\\., ;: \s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

export default function validateEmail(email: string): boolean {
  // from https://stackoverflow.com/questions/46155/how-to-validate-an-email-address-in-javascript
  const re = emailRegex;
  return re.test(String(email).toLowerCase());
}
